import { flow, map } from "es-toolkit/compat";

import type { RequiredData } from "#app/(required)/useRequiredData";
import type { Jwt } from "#app/(unauthorized)/authentication/jwt";
import type { NavRoutesConfig } from "#app/_ui/components/headers/nav-routes-config";

import aggregatorsFilter from "./aggregatorsFilter";
import allowedSegmentFilter from "./allowedSegmentsFilter";
import aplQueryFilter from "./aplQueryFilter";
import clientNavFilter from "./clientNavFilter";
import finPlanningNavFilter from "./finPlanningNavFilter";
import heldawayFilter from "./heldawayFilter";
import impersonationFilter from "./impersonationFilter";
import institutionalFilter from "./institutionalFilter";
import notLoggedInNavFilter from "./notLoggedInNavFilter";
import preclientNavFilter from "./preclientNavFilter";
import trustNavFilter from "./trustNavFilter";

interface FilterNavRoutesConfigParams {
  jwt: Jwt;
  navRoutesConfig: NavRoutesConfig;
  requiredData: RequiredData;
}

export type NavRoutesConfigFilterParams = FilterNavRoutesConfigParams;

type NavRoutesConfigFilter = (
  params: NavRoutesConfigFilterParams,
) => NavRoutesConfig;

const filters = [
  allowedSegmentFilter,
  notLoggedInNavFilter,
  preclientNavFilter,
  clientNavFilter,
  institutionalFilter,
  finPlanningNavFilter,
  aplQueryFilter,
  trustNavFilter,
  heldawayFilter,
  impersonationFilter,
  aggregatorsFilter,
] as const satisfies NavRoutesConfigFilter[];

export function filterNavRoutesConfig({
  jwt,
  navRoutesConfig,
  requiredData,
}: FilterNavRoutesConfigParams): NavRoutesConfig {
  const createFilter =
    (filterFn: NavRoutesConfigFilter) => (config: NavRoutesConfig) =>
      filterFn({ navRoutesConfig: config, jwt, requiredData });

  return flow(map(filters, createFilter))(navRoutesConfig) as NavRoutesConfig;
}
